import Language from './language';
import { Switch as cSwitch } from '@coreui/vue';
import { api } from '@/f1/service';
import punycode from 'punycode';
import result from  '../../result/Result.Detail.i18n'
import QuickSetup from  '../Site.Quick.Setup.i18n'
import reg from '@/f1/reg';
import codes from '@/f1/codes';
import _ from 'lodash';
import { signalr } from '@/f1/service'
import htmlViewer from '../../detect/Detect.Viewer.i18n';
import VclFacebook from 'vue-content-loading';

//restful api
//import { wmds as ws } from '@/f1/service/api'

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

// 초기 필요한 데이터 시작
const default_model = () => ({
  is_alive: true, is_cron: false, is_start: true, is_js: true,
  schedule: [], config: { seeds : [], subs: [], prevents: [] }
});

const policy = {
  S : { depth: 5, links: 20, limit: 200 },
  M : { depth: 10, links: 50, limit: 2000 },
  L : { depth: 20, links: 100, limit: 10000 }
}
let min = {
  EN : 'min',
  KO : '분',
  JP: '分'
}

let hour = {
  EN : 'hour',
  KO : '시',
  JP: '時間'
}

// let interval = {
//   EN : 'interval',
//   KO : '매',
// }

let h_opt = {
  EN : [
    { value: '*', text: 'every hour' },
    { value: '*/2', text: '2 hour interval'},
    { value: '*/3', text: '3 hour interval'},
    { value: '*/4', text: '4 hour interval'}
  ],
  KO : [
    { value: '*', text: '매시간' },
    { value: '*/2', text: '2 시간마다'},
    { value: '*/3', text: '3 시간마다'},
    { value: '*/4', text: '4 시간마다'}
  ],
  JP: [
    { value: '*', text: '毎時' },
    { value: '*/2', text: '2時間間隔'},
    { value: '*/3', text: '3時間間隔'},
    { value: '*/4', text: '4時間間隔'}
  ]
};

let m_opt = {
  EN : [
    { value: '*', text: 'every min' },
    { value: '*/5', text: '5 min interval'},
    { value: '*/10', text: '10 min interval'},
    { value: '*/15', text: '15 min interval'},
    { value: '*/20', text: '20 min interval'},
    { value: '*/30', text: '30 min interval'},
    { value: '*/45', text: '45 min interval'}
  ],
  KO : [
    { value: '*', text: '매분' },
    { value: '*/5', text: '5 분 마다'},
    { value: '*/10', text: '10 분 마다'},
    { value: '*/15', text: '15 분 마다'},
    { value: '*/20', text: '20 분 마다'},
    { value: '*/30', text: '30 분 마다'},
    { value: '*/45', text: '45 분 마다'}
  ],
  JP: [
    { value: '*', text: '毎分' },
    { value: '*/5', text: '5分間隔'},
    { value: '*/10', text: '10分間隔'},
    { value: '*/15', text: '15分間隔'},
    { value: '*/20', text: '20分間隔'},
    { value: '*/30', text: '30分間隔'},
    { value: '*/45', text: '45分間隔'}
  ]
}
// 초기 필요한 끝

export default {
  props : ['is_first'],
  components: { cSwitch, result, QuickSetup, Language, htmlViewer, VclFacebook },
  // filters: {

  // },
  computed: {
    opt_login_msg() {
      if(!this.model.login_url) { return _i18n_data._i18n_msg.require_login_url[this.i18n]}
      else if(!this.model.html) { return _i18n_data._i18n_msg.require_login_crawling[this.i18n]}
      else if(!this.opt_login.username && !this.opt_login.password && !this.opt_login.el_username && !this.opt_login.el_password && !this.opt_login.el_submit) { return _i18n_data._i18n_msg.require_login[this.i18n]}
      else if(!this.opt_login.el_username) { return _i18n_data._i18n_msg.require_el_username[this.i18n]}
      else if(!this.opt_login.username) { return _i18n_data._i18n_msg.require_username[this.i18n]}
      else if(!this.opt_login.el_password) { return _i18n_data._i18n_msg.require_el_password[this.i18n]}
      else if(!this.opt_login.password) { return _i18n_data._i18n_msg.require_password[this.i18n]}
      else if(!this.opt_login.el_submit) { return _i18n_data._i18n_msg.require_el_submit[this.i18n]}
    },
    // i18n_data() { return _i18n_data; },
    filteredList() {
      if(this.postList)
      {
        return this.postList.filter(post => {
          return post.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    },
  },
  data : () => {
    return {
      opt_login : {
        is_show : false,
        is_iframe : false,
        modal_props : false,
        modal_explain : false,
        el_username : '',
        el_password : '',
        el_submit : '',
        username : '',
        password : '',
        sel_props : ''
      },
      tab_index : 1,
      reg,
      loading: false,
      postList : [],
      pro : 'username',
      modal : false,
      row_id : -1,
      row_position : -1,
      signalr,
      modal_charge_agree : false,
      msg : '',
      modal_explain : false,
      del_nickname : '',
      codes,
      options : [],
      max_schedule : 10,
      policy : policy,
      v : {},
      isLoadPolicy : false,
      cc : undefined,
      policy_list : [],
      s : { schedule: '0 *', h: '*', h_opt: h_opt, m: '0', m_opt : m_opt },
      del_confirm: false,
      del_name: false,
      add: false,
      lock: true,
      lock2 : false,
      search : '',
      doc : null,
      username : null,
      password : null,
      group_list: undefined,
      model : default_model(),
      result : {},
      confirm_result : false,
      child : null,
      temp_user : false,
      temp_pass : false,
      temp_submit : false
    }
  },
  methods: {
    cron_filter: function (v) {
      if (!v) return '';
      let vs = v.trim().split(' ');
      let m = _.find(m_opt[this.i18n], { value: vs[0] });
      let h = _.find(h_opt[this.i18n], { value: vs[1] });
      // console.log('m', m)
      // console.log('h', h)
      return (h && h.text || vs[1]) + ' ' + (m && m.text || vs[0])
    },
    async click_account(event){

      console.log(event)

      let target = event.target.id.replace(/_/gm, '')
      let value = event.target.value

      location.hostname == 'localhost' ? console.log(event, target, value) : ''
      let is_username = event.target.outerHTML.toLowerCase().indexOf(this.opt_login.el_username.toLowerCase()) > -1
      let is_password = event.target.outerHTML.toLowerCase().indexOf(this.opt_login.el_password.toLowerCase()) > -1

      if(!is_username && !is_password) {
        console.log("event, target", 'no have el from option', is_username, is_password, event.target.outerHTML)
        return
      }

      if(this.opt_login.el_username) {
        // id
        if(this.opt_login.el_password) {
          if(is_password) {
            this.opt_login.password = value
          } else {
            console.log("is not password value from unique string", event.target.outerHTML)
          }
          // this.opt_login.password = !this.opt_login.password ? value : this.opt_login.password
        } else {
          // if(!this.opt_login.username) {
          //   return console.log("set username first")
          // }
          // this.opt_login.username = !this.opt_login.username ? value : this.opt_login.username
          if(is_username) {
            this.opt_login.username = value
          } else {
            console.log("is not username value from unique string", event.target.outerHTML)
          }
        }

      } else {
        this.opt_login.el_username = value
      }
    },
    show_modal(event) {
      if(this.opt_login.modal_props) {
        console.log(this.i18n_data['exist_value'][this.i18n])
        return
      }
      // 클릭한 이벤트의 모든 프로펄리티를 리턴함
      this.opt_login.props = _.map(event.target.attributes, props => `${props.nodeName}="${props.nodeValue}"`.toLocaleLowerCase())

      if((!this.opt_login.el_username || !this.opt_login.el_password) && event.target.localName != 'input') {
        console.log('it is not input for username, password', this.opt_login.el_username, this.opt_login.el_password)
        return true
      }
      // 중복 체크 안함, 사용자 선택에 맡김
      console.log(event)
      if(_.filter(this.opt_login.props, x => x == this.opt_login.el_username || x == this.opt_login.el_password).length > 0) {
        console.log('already used it', this.opt_login.props)
        // alert(this.i18n_data['exist_value'][this.i18n])
        return true
      }
      this.opt_login.modal_props = true
      console.log(event, this.opt_login.props)
    },
    popup(clean=false){
      // if(this.opt_login.username && this.opt_login.password && this.opt_login.el_password && this.opt_login.el_username && this.opt_login.el_submit) {
      //   return alert(this.i18n_data['login_input_setting'][this.i18n])
      // }
      // console.log('this.model.html', this.aa)
      if(!this.model.html) { return this.$toastr.w(`${_i18n_data._i18n_msg.login_check_failed[this.i18n]}`) }
      alert(`${_i18n_data._i18n_msg.login_description[this.i18n]}`)

      try {
        if(window['uwss_opt_login_child']) {
          window['uwss_opt_login_child'].close()
        }
      } catch(e) { console.log(e) }

      this.child = window.open('about:blank', "Account Information", "width=400, height=480, left=150, top=10")

      if(clean) {
        let data = this.model.html.replace(/link href=/g, 'aa').replace(/script/g, 'a').replace(/base href=/g, 'a')

        this.child.document.write(data)

        console.log(data)
      } else {
        this.child.document.write(this.model.html)
      }

      window['uwss_opt_login_child'] = this.child

      this.child.addEventListener('change', event => this.click_account(event))
      // this.child.addEventListener('click', event => this.click_now(event))
      this.child.addEventListener('click', event => this.show_modal(event))
    },
    opt_login_select() {
      console.log('opt_login', this.opt_login)
      if(!this.opt_login.el_username) { this.opt_login.el_username = this.opt_login.sel_props }
      else if(!this.opt_login.el_password) { this.opt_login.el_password = this.opt_login.sel_props }
      else if(!this.opt_login.el_submit) {
        this.opt_login.el_submit = this.opt_login.sel_props
        this.opt_login.step = 3
      }
      this.opt_login.modal_props = false

      if(this.opt_login.el_username && this.opt_login.el_password && this.opt_login.el_submit && this.opt_login.username && this.opt_login.password) {
        this.$toastr.w(`${_i18n_data._i18n_msg.login_info[this.i18n]}`); setTimeout(() => this.child.close(), 3000)
      }
    },
    login_test(){
      console.log(this.model.login_url)
      let login = window.open(this.model.login_url, "LoginTest", "width=400, height=300, left=100, top=50")
      // 아래는 원하는 로직이나 보안 이슈상 불가, 메모용으로 코드 남김
      // login.document.body.innerHTML += `
      // <script>
      //   let username = document.getElementById(${this.model.el_username})
      //   username.value = ${this.model.el_username}

      //   let password = document.getElementById(${this.model.el_password})
      //   password.value = ${this.model.el_username}

      //   let submit = document.getElementById(${this.model.el_submit})
      //   submit.click()

      // </script>
      // `
    },
    async test() {
      try {
        this.loading = true;

        // 입력 검증
        if(!this.model.login_url || !this.model.login_url.trim() || !this.reg.reg_fqdn_with_protocol.test(this.model.login_url)) {
          return this.$toastr.e(`${_i18n_data._i18n_msg.require_login_url[this.i18n]}`);
        } else {
          this.model.login_url = this.model.login_url.trim()
        }

        this.check_login()
        // task_key : 없으면 통과하지 못함
        // console.log(signalr.socket())

        // 해당 api 는 에이전트와 통신하기 위해서 필요한 api.
        let rs = await api.wmds.WMDS_Call('rpc', "singleagent", { site_id: this.model.id, url: this.model.login_url });
        //Todo : Restful api 생성작업이 필요함. 이후 통신여부 확인해야함.
        //api 호출 오류 발생시 backend 에서 target:start, cmd:start 인 api 를 호출할수없을 가능성이 큼.
        //let rs = await ws.site.rpc({ site_id: this.model.id, url: this.model.login_url });

        console.log(rs.body)
        if (rs.error) {
          // this.loading = false;
          this.$toastr.e(`${_i18n_data._i18n_msg.login_check_failed[this.i18n]}`); this.refresh();
          return
        }
        this.model.html = ''
        this.model.html = rs.body
        this.postList = this.model && this.model.html && this.model.html.split('\n');

        // 기존 정보 초기화
        this.temp_user = false
        this.temp_pass = false
        this.temp_submit = false
        this.model.username = this.model.password = this.model.el_username = this.model.el_password = this.model.el_submit = ''
        this.loading = false;
        this.$toastr.s(`${_i18n_data._i18n_msg.next_login_check[this.i18n]}`);


        // api html 정보 업데이트
        try {
          let html_data = { id : this.model.id, html : this.model.html }
          let rs = await api.wmds.WMDS_Call('site', 'update', html_data);
          //let rs = await ws.site.update(html_data);
          if (rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`); }
        } catch (e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.update_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText); }

      } catch (e) { console.info(e); this.loading = false; this.$toastr.e(`${_i18n_data._i18n_msg.login_check_failed[this.i18n]}`) }
      finally { this.loading = false; }
    },
    load_recent_result() {
      var search = {
        target: 'result',
        cmd: 'list',
        limit: 1,
        offset: 0,
        body: {
          and: [{ name: 'is_del', value: false, op: '=' }, { name: 'site_id', value: this.model.id, op: '=' }],
          or: [],
          sort: [{ name: 'id', op: 'desc' }]
        }
      };
      api.wmds.WMDS(search)
      //ws.result.list(search)
        .then(rs => { rs.body && rs.count > 0 ? this.result = rs.body[0] : {}; })
        .catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText));
    },
    go_result(id) { this.$router.push({ name: 'wmds_result', params: { id: id } }); },
    check_login() {
      try {
        this.model.login_url = _.trim(this.model.login_url)

        if (!this.model.login_url || !reg.url_path.test(punycode.toASCII(this.model.login_url))) {
          this.$refs.login_url.$el.focus();
          this.loading = false;
          return this.$toastr.w(`${_i18n_data._i18n_warning.login_check[this.i18n]}`);
        }
      } catch (e) { console.error(e); }
    },
    // ui method
    check_fqdn() {
      try {
        this.model.fqdn = _.trim(this.model.fqdn);
        if (!this.model.fqdn || !reg.domain.test(punycode.toASCII(this.model.fqdn))) { this.$refs.fqdn.$el.focus(); return this.$toastr.w(`${_i18n_data._i18n_warning.domain_check[this.i18n]}`); }
        if (reg.prevent_domain.test(punycode.toASCII(this.model.fqdn))) { this.$refs.fqdn.$el.focus(); return this.$toastr.w(`${i18n_data._i18n_warning.domain_check[this.i18n]}`); }
        let seeds = this.model.config.seeds;
        if (!_.includes(seeds, 'http://' + this.model.fqdn) && !_.includes(seeds, 'https://' + this.model.fqdn)) {
          // seeds.push('http://' + );
          this.add_seed('https://' + this.model.fqdn);
        }
        let subs = this.model.config.subs;
        if (_.startsWith(this.model.fqdn, 'www.') && !_.includes(subs, this.model.fqdn.substr(4))) { subs.push(this.model.fqdn.substr(4)); }
        if (!this.model.name) {
          let vn = this.model.fqdn.split('.');
          this.model.name = _.startsWith(this.model.fqdn, 'www.') ? vn[1] : vn[0];
        }
      } catch (e) { console.error(e); }
    },

    // schedule
    schedule_filter: function (v) {
      if (!v)
        return '';
      // let vs = v.trim().split(' ');
      // let m = _.find(m_opt, { value: vs[0] });
      // let h = _.find(h_opt, { value: vs[1] });
      return `${v} * * *`;
    },
    response_handler(rs) {
      console.info(rs, "ASDFASDF");
    },
    add_schedule() {

      if (this.s.schedule == '* *') { return this.$toastr.w(`${_i18n_data._i18n_warning.schedule_check[this.i18n]}`); }
      if (!this.s.schedule) { return this.$toastr.w(`${_i18n_data._i18n_warning.schedule_check_2[this.i18n]}`); }
      let schedules = this.model.schedule;
      if (_.filter(schedules, s => _.startsWith(s, this.s.schedule)).length) { this.s.schedule = undefined; return this.$toastr.i(`${_i18n_data._i18n_warning.is_schedule[this.i18n]}`); }
      let sch = this.schedule_filter(this.s.schedule);
      schedules.push(sch); this.s.schedule = undefined;
    },
    // TODO : 현재 미사용 처리됨
    // add_schedule_custom() {
    //   if(!this.s.schedule_custom) { return; }
    //   let schedules = this.model.schedule;
    //   if(_.includes(schedules, this.s.schedule_custom)) { this.s.schedule_custom = undefined; return this.$toastr.i('Already existing'); }
    //   // check cron grammar
    //   let arraySche = this.s.schedule_custom.split(' ');
    //   for (let l = 0; l < arraySche.length; l++) {
    //     const e = arraySche[l];
    //     let r = e.split(",")
    //     for (let k = 0; k < r.length; k++) {
    //       const rr = r[k];
    //       // if length is 5, have 5 at lest 6 *
    //       switch (arraySche.length > 4 ? l -1 : l) {
    //         case 0: !(rr <= 59 && rr > 0) ? this.$toastr.e("incorrect cron sec") : ''; break; // sec range 0 ~ 59
    //         case 1: !(rr <= 59 && rr > 0) ? this.$toastr.e("incorrect cron min") : ''; break; // min range 0 ~ 59
    //         case 2: !(rr <= 23 && rr > 0) ? this.$toastr.e("incorrect cron hour") : ''; break; // hour range 0 ~ 23
    //         case 3: !(rr <= 31 && rr > 0) ? this.$toastr.e("incorrect cron day of month") : ''; break; // day of month range 0 ~ 31
    //         case 4: !(rr <= 12 && rr > 0) ? this.$toastr.e("incorrect cron month") : ''; break; // month range 0 ~ 12
    //         case 5: !(rr <= 6 && rr > 0) ? this.$toastr.e("incorrect cron weekday") : ''; break; // weekday range 0 ~ 6
    //         default: console.log("not support "); break;
    //       }
    //     }
    //   }
    //   console.log(schedules, "good")
    //   // schedules.push(this.s.schedule_custom); this.s.schedule_custom = undefined;
    //   console.info("updated", schedules)
    // },
    remove_schedule(a) { this.model.schedule = Object.assign(_.without(this.model.schedule, a)); },
    // seed
    add_seed(url = '') {
      // console.log(this.v.seed, this.model.fqdn, this.v.seed.indexOf(this.model.fqdn) < 0)
      this.v.seed = url ? url : _.trim(this.v.seed);
      // if(!this.v.seed || this.v.seed.indexOf(this.model.fqdn) < 0) { return this.$toastr.w("Start URL does not contain FQDN") }
      let seeds = this.model.config.seeds;
      if (!reg.url_path.test(this.v.seed)) { return this.$toastr.e(`${_i18n_data._i18n_warning.url_check[this.i18n]}`); }
      if (_.includes(seeds, this.v.seed)) { this.v.seed = undefined; return this.$toastr.i(`${_i18n_data._i18n_warning.is_schedule[this.i18n]}`); }
      seeds.push(this.v.seed); this.v.seed = undefined;
    },
    remove_seed(a) { this.model.config.seeds = Object.assign(_.without(this.model.config.seeds, a)); },

    // subs
    add_sub() {
      this.v.sub = _.trim(this.v.sub);
      let subs = this.model.config.subs;
      if (!reg.domain.test(punycode.toASCII(this.v.sub))) { this.$refs.sub_domains.$el.focus(); return this.$toastr.e(`${_i18n_data._i18n_warning.subDomain_check[this.i18n]}`); }
      if (this.v.sub == this.model.fqdn) { this.v.sub = undefined; return this.$toastr.i(`${_i18n_data._i18n_warning.FQDN_check[this.i18n]}`); }
      if (_.includes(subs, this.v.sub)) { this.v.sub = undefined; return this.$toastr.i(`${_i18n_data._i18n_warning.is_schedule[this.i18n]}`); }
      subs.push(this.v.sub); this.v.sub = undefined;
    },
    remove_sub(a) { this.model.config.subs = Object.assign(_.without(this.model.config.subs, a)); },
    add_prevent() {
      this.v.prevent = _.trim(this.v.prevent);
      let prevents = this.model.config.prevents;
      if (!reg.url_path.test(this.v.prevent)) { this.$refs.prevent.$el.focus(); return this.$toastr.e(`${_i18n_data._i18n_warning.url_check[this.i18n]}`); }
      if (_.includes(prevents, this.v.prevent)) { this.v.prevent = undefined; return this.$toastr.i(`${_i18n_data._i18n_warning.is_schedule[this.i18n]}`); }
      prevents.push(this.v.prevent); this.v.prevent = undefined;
    },
    remove_prevent(a) { this.model.config.prevents = Object.assign(_.without(this.model.config.prevents, a)); },
    schedule(e, t) { this.s.schedule = t == 'h' ? `${this.s.m} ${e}` : `${e} ${this.s.h}`; },
    cancel() { this.$router.replace({ name: 'wmds_site', params: { id: this.model.id } }); },
    edit() {
      this.$router.replace({ name: 'wmds_site', params: { id: this.$route.params.id, tag: 'edit' } });
      this.lock = true;
    },

    // site manage
    async remove() {
      try {
        this.del_nickname = (this.del_nickname || '').trim();
        if (this.model.name.trim() != this.del_nickname) { return this.$toastr.e(`${_i18n_data._i18n_error.sitename_check[this.i18n]}`); }
        this.del_nickname = '';
        this.del_confirm = false;
        let rs = await api.wmds.WMDS_Call('site', 'delete', { id: this.model.id });
        //let rs = await ws.site.delete({ id: this.model.id });
        if (rs.error) { return this.$toastr.e(this.$route.name, `${i18n_data._i18n_error.failed[this.i18n]}`); }
        this.$parent.$emit('refresh'); this.$toastr.s(`${i18n_data._i18n_success.removed[this.i18n]}`); this.list();
      } catch (e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.remove_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText), this.list(); }
    },
    list() { this.$router.push({ name: 'wmds_site' }); },
    cron_parse(cron, is_add = true) {
      let origin = cron.split(' ');
      // console.log('origin', origin, origin[1] != '*' ? origin[1].replace(/[\\*]/gm, '') : 0)
      let min_has_interval = origin[0].indexOf('/') > -1;
      let hour_has_interval = origin[1].indexOf('/') > -1;
      if (hour_has_interval) {

        // 매시간별 반복은 시간 차이 기준으로 컨버팅 불필요
      } else {
        if (origin[1] != '*') {
          origin[1] = (Number(origin[1] != '*' ? origin[1].replace(/[/|\\*]/gm, '') : 0) + 24 + (is_add ? +(new Date().getTimezoneOffset() / 60) : -(new Date().getTimezoneOffset() / 60))) % 24;
        }
      }

      if (min_has_interval) { '*/' + origin[0]; }
      if (hour_has_interval) { '*/' + origin[1]; }
      // console.log(origin.join(' '))
      return origin.join(' ');
    },
    policy_manage() { this.$router.replace({ name: 'wmds_policy', params: { id: this.model.policy_id } }); },
    async save() {
      this.model = Object.assign({}, this.model, this.opt_login)
      let has_login_data = (this.model.username && this.model.password && this.model.el_password && this.model.el_username && this.model.el_submit && this.model.login_url)
      if(this.model.is_login == true && !has_login_data) {
        return this.$toastr.e(`${_i18n_data._i18n_error.is_login[this.i18n]}`)
      }
      let config = this.model.config;
      if (!this.model.policy_id) { this.$refs.policy.$el.focus(); return this.$toastr.e(`${_i18n_data._i18n_error.policyId_check[this.i18n]}` + `${_i18n_data._i18n_error.required_value[this.i18n]}`); }
      if (!(this.model.fqdn || '').trim()) { this.$refs.fqdn.$el.focus(); return this.$toastr.e(`${_i18n_data._i18n_error.fqdn[this.i18n]}` + `${_i18n_data._i18n_error.required_value[this.i18n]}`); }
      if (reg.prevent_domain.test(punycode.toASCII(this.model.fqdn))) { return this.$toastr.e(`${i18n_data._i18n_warning.domain_check[this.i18n]}`); }
      if (!this.model.schedule.length) { this.$refs.schedule.$el.focus(); return this.$toastr.e(`${_i18n_data._i18n_warning.schedule_check_3[this.i18n]}`); }
      if (!config.seeds.length) { return this.$toastr.e(`${_i18n_data._i18n_warning.url_check_2[this.i18n]}`); }
      this.model.name = this.model.name.trim()

      //
      let schedule = _.map(this.model.schedule, r => this.cron_parse(r));
      // console.log('saved', schedule);

      try {
        let rs = await api.wmds.WMDS_Call('site', this.model.id ? 'update' : 'insert', Object.assign({}, this.model, { schedule: schedule }));

        // let check_id = this.model.id ? `${await ws.site.update(Object.assign({}, this.model, { schedule: schedule }))}` : `${await ws.site.insert(Object.assign({}, this.model, { schedule: schedule }))}`
        // let rs = check_id

        if (rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.save_failed[this.i18n]}`); }
        this.$toastr.s(`${i18n_data._i18n_success.saved[this.i18n]}`);
        this.$parent.$emit('refresh'); this.cancel();
      } catch (e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.save_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText); }
      this.lock = true;
    },
    async change(index) {
      try {
        let rs = await api.wmds.WMDS({ target: 'policy', cmd: 'detail', body: { id: index } });
        //let rs = await ws.policy.detail({ id: index })
        if (rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.policy_load[this.i18n]}`); }

        this.policy = rs.body.policy;
        this.policy.description = this.policy.description ? this.policy.description : rs.body.description;
        this.model.policy_id = index;
        this.isLoadPolicy = true;

        console.log("reload", this.policy.description);
      } catch (e) { console.log(e); }
    },
    async get({ id, tag } = this.$route.params) {
      // this part change dynamic loding
      this.add = false;
      let so = {
        target: 'policy', cmd: 'list',
        body: { sort: [{ name: 'id', op: 'desc' }], or: [], and: [{ name: "is_del", value: false, op: '=' }] },
      };
      let rs = await api.wmds.WMDS(so);
      //let rs = await ws.policy.list(so);
      if (rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`); }
      this.policy_list = (rs.body || []).map(r => {
        r.description = r.description;
        if (r.description == undefined) { r.description = r.policy.description; }
        // console.log(r, 'r')
        return r;
      });

      this.lock = (tag !== 'edit');

      if (id == 'add') { this.add = true; this.lock = false; return; }

      let checkPolicyList = _.map(this.policy_list, r => { return r.id; });
      this.model = Object.assign({ group: {} }, this.model, (await api.wmds.WMDS_Call('site', 'detail', { id: id })).body);
      //this.model = object.assign({ group: {} }, this.model, () await ws.site.detail({ id: id }) ).body);
      var parser = new DOMParser();
      let a = parser.parseFromString(this.model.html, "text/html");
      // let doctype = '<!DOCTYPE html>';
      let html = a.documentElement.outerHTML;

      this.doc = html;
      // this.doc = a.documentElement;
      window.x = this.doc;
      this.opt_login.username  = this.model.username ? this.model.username : ''
      this.opt_login.password  = this.model.password ? this.model.password : ''
      this.opt_login.el_username  = this.model.el_username ? this.model.el_username : ''
      this.opt_login.el_password  = this.model.el_password ? this.model.el_password : ''
      this.opt_login.el_submit  = this.model.el_submit ? this.model.el_submit : ''

      // console.info(iframeDoc)
      this.postList = this.model && this.model.html && this.model.html.split('\n');
      // console.info(a)
      if (checkPolicyList.includes(this.model.policy_id)) {
        let result = await api.wmds.WMDS_Call('policy', 'detail', { id: this.model.policy_id });
        // let result = await ws.policy.detail({ id: this.model.policy_id });
        if (result.error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`); }

        this.policy = Object.assign({}, this.policy, result.body.policy, { description: result.body.description });
        if (this.policy.description == undefined) { this.policy.description = result.body.policy.description; }
        this.isLoadPolicy = true;
      }

      // if(location.hostname == 'localhost') { this.model.schedule = ["*/5 * * * *", "4 * * * *","2 2 * * *",  "*/2 */2 * * *", "* */2 * * *", "*/30 */2 * * *", "5 */2 * * *", "* 5 * * *", "*/15 5 * * *", "8 5 * * *"] }
      this.model.schedule = _.map(this.model.schedule, r => this.cron_parse(r, false));
      this.load_recent_result();
    },
    refresh() { this.$parent.$emit('refresh'); },
    async charge_agree() {
      try {
        let rs = await api.wmds.WMDS_Call('site', 'agree', { ts: new Date().getTime() });
        //let rs = await ws.site.agree({ ts: new Date().getTime() });
        if (rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.agreement_failed[this.i18n]}`); }
        // 시스템 로그가 남아야 함, 동의 부분 관련
        this.save();
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.agreement_failed[this.i18n]}`); }
    },
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from.path) } },
  created: function() {  console.log('site.detail.kr.vue', 'created'); },
  destroyed: function() {
    if(this.child) { this.child.close(); }
    console.log('site.detail.kr.vue', 'destroyed'); this.signalr.off('wmds', this.response_handler) },
  mounted: function() {
    this.signalr.on('wmds', (x) => console.log(x))
    console.log('site.detail.kr.vue', 'mounted', this.i18n);
    this.get(this.$route.params);
    for(let i = 0; i < 60; i++) { m_opt[this.i18n].push({ value: i.toString(), text: i +  ` ${min[this.i18n]}` }); console.log(min[this.i18n]); }
    for(let i = 0; i < 24; i++) { h_opt[this.i18n].push({ value: i.toString(), text: i + ` ${hour[this.i18n]}` }); }

    if(location.hostname == 'localhost') {
      this.tab_index = 1
    }
  },
}
